/* eslint-disable no-bitwise */

/**
 * Hace que no se desborde
 * @param {number} numericColor
 * @returns
 */
const formatNumericColor = (numericColor) => {
  if (numericColor > 255) {
    return 255;
  }
  if (numericColor < 0) {
    return 0;
  }
  return numericColor;
};

/**
 * Funcion que calcula el color mas claro u oscuro dado una cantidad
 *
 * @param {string} color // Color en hexadecimal
 * @param {number} amount // Cantidad para oscurecer o aclarar, para oscurecer pasar valores negativos
 * @returns
 */
const lightenDarkenColor = (color, amount) => {
  const numericColor = parseInt(color.slice(1), 16);

  let r = (numericColor >> 16) + amount;
  r = formatNumericColor(r);

  let b = ((numericColor >> 8) & 0x00ff) + amount;
  b = formatNumericColor(b);

  let g = (numericColor & 0x0000ff) + amount;
  g = formatNumericColor(g);

  return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
};
export default lightenDarkenColor;
